<app-preloader *ngIf="settings.isShowingLoader()"></app-preloader>

<div class="main-banner item-bg-three">
    <div class="creative-banner-two"></div>
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="main-banner-text">
                    <h4>Qual è il post più piaciuto?<br><br>
                        Te lo diciamo noi!</h4>
                    <h1>Scopri i post della settimana di
                        <ngx-typed-js [backSpeed]="100"
                                      [loop]="true"
                                      [showCursor]="false"
                                      [strings]="['Instagram', 'TikTok']"
                                      [typeSpeed]="100">
                            <span class="typing"></span>
                        </ngx-typed-js>
                    </h1>
                    <p>Seguici e sarai sempre aggiornato sui post di maggior successo!</p>
                    <a class="btn btn-primary" (click)="onClick('charts')">Scopri le nostre classifiche</a>
                </div>
            </div>
        </div>
    </div>
</div>

<app-home-chart></app-home-chart>

<app-charts-service></app-charts-service>

<app-how-we-work></app-how-we-work>

<app-contact></app-contact>
